
// 获取渠道列表(不分页)
import { getChannelAll } from "@/api/marke.js";
// 存储渠道列表数据
export default {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    CHANEG_CHANNEL(state, item) {
      getChannelAll().then(res => {
        if (res.data.code === 200) {
          state.items = res.data.data
          localStorage.setItem('channelArr', JSON.stringify(state.items))
        }
      })
    },
    ADD_CHANNEL(state, item) {
      state.items.push(item)
      localStorage.setItem('channelArr', JSON.stringify(state.items))
    },
    DELETE_CHANNEL(state, id) {
      state.items = state.items.filter(item => item.id !== id)
      localStorage.setItem('channelArr', JSON.stringify(state.items))
    },
    UPDATE_CHANNEL(state, updatedChannel) {
      const index = state.items.findIndex(item => item.id === updatedChannel.id)
      if (index !== -1) {
        state.items.splice(index, 1, Object.assign({}, state.items[index], updatedChannel))
      }
      localStorage.setItem('channelArr', JSON.stringify(state.items))
    }
  },
  actions: {
    changeChannel({ commit }, item) {
      commit('CHANEG_CHANNEL', item)
    },
    addChannel({ commit, state }, item) {
      const newId = state.items.length > 0 ? state.items[state.items.length - 1].id + 1 : 1
      const newItem = { ...item, id: newId }
      commit('ADD_CHANNEL', newItem)
    },
    deleteChannel({ commit, state }, id) {
      commit('DELETE_CHANNEL', id)
    },
    updateChannel({ commit, state }, updatedChannel) {
      commit('UPDATE_CHANNEL', updatedChannel)
    }
  }
}